import { render, staticRenderFns } from "./IconUnfold.vue?vue&type=template&id=00b6d66a&"
import script from "./IconUnfold.vue?vue&type=script&lang=js&"
export * from "./IconUnfold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports